import _ from 'lodash';
import { toastError } from '../../components/toastify';
import { queryFinishedProcess, queryProcessTaskList, queryShareofficeApplyById, queryShareofficeChangeById, queryShareofficeWaitById, queryTodoProcess, updateSignedProcess } from '../../_db/api.service';
import { FULL_SIGNATURE, GLOBAL_CATALOGS, TODO_STATUS_CODE, WITH_SIGN_CODE } from '../types';

export const querySignOffMenus = (list = []) => (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.SignOff.Root,
    payload: list
  });
};


export const onChangeSignOffTabsItem = (value, title) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_SIGNATURE.Value,
    payload: value
  });
};


// 待我簽核List
export const queryUndisposedList = ({
  startTime,
  endTime,
  processName,
  formIds = 'ShareOffice_applyOrder,ShareOffice_waitOrder,ShareOffice_changeOrder',
  businessFormNo,
  createUserRealname,
  page = 1,
  rowsPerPage = 10
}) => async (dispatch, getState) => {
  const { signature } = await getState();

  await dispatch({
    type: FULL_SIGNATURE.Loading,
    payload: true
  });
  
  const { success, result } = await queryTodoProcess({ startTime, endTime, processName, formIds, businessFormNo, createUserRealname, pageNo: page, pageSize: rowsPerPage });
  const { records, current, pages, size, total } = result || {};
    

  dispatch({
    type: GLOBAL_CATALOGS.SignOff.Waiting.List,
    payload: {
      list: records,
      total,
      page: current,
      rowsPerPage: size,
      pages,
    }
  });

  setTimeout(() => {
      dispatch({
        type: FULL_SIGNATURE.Loading,
        payload: false
      });
  }, 260);
};



// 我已簽核
export const queryProcessedList = ({
  startTime,
  endTime,
  processName,
  formIds = 'ShareOffice_applyOrder,ShareOffice_waitOrder,ShareOffice_changeOrder',
  businessFormNo,
  createUserRealname,
  page = 1,
  rowsPerPage = 10
}) => async (dispatch, getState) => {
  const { signature } = await getState();

  await dispatch({
    type: FULL_SIGNATURE.Loading,
    payload: true
  });

  const { success, result } = await queryFinishedProcess({ startTime, endTime, processName, formIds, businessFormNo, createUserRealname, pageNo: page, pageSize: rowsPerPage });
  const { records, current, pages, size, total } = result || {};
  dispatch({
    type: GLOBAL_CATALOGS.SignOff.Signed.List,
    payload: {
      list: records,
      total,
      page: current,
      rowsPerPage: size,
      pages,
    }
  });

  setTimeout(() => {
      dispatch({
        type: FULL_SIGNATURE.Loading,
        payload: false
      });
  }, 260);
};


// 同意或者退回作業
export const createProcessedItem = ({ businessFormNo, action, reviewerId, remarks }) => async (dispatch, getState) => {
  const { signature } = await getState();
  const { success, message, result } = await updateSignedProcess({ businessFormNo, action, reviewerId, remarks });
  return { success, message, result };
};



//  查詢簽核單據詳情 SO 申请单 ; LA 候補 ; CR 变更单
export const querySignOffItem = (payload) => async (dispatch, getState) => {
  const { businessFormNo } = payload || {};

  // 是否候補单
  const isLA = businessFormNo?.includes('LA');

  // 是否變更單
  const isCR = businessFormNo?.includes('CR');

  // 單據--基本資訊 需求資訊
  const { success: success1, message: message1, result: result1 } = isLA 
    ? await queryShareofficeWaitById({ formNo: businessFormNo }) 
    : ( 
      isCR 
      ? await queryShareofficeChangeById({ formNo: businessFormNo }) 
      : await queryShareofficeApplyById({ formNo: businessFormNo })
    );

  // 單據--簽核節點記錄
  const { success: success2, message: message2, result: result2 } = await queryProcessTaskList({ businessFormNo, withSignCode: [TODO_STATUS_CODE.signing].includes(result1?.status) ? WITH_SIGN_CODE.True : WITH_SIGN_CODE.False });
  const schedule = [TODO_STATUS_CODE.signing].includes(result1?.status) ? [
    ...(Array.isArray(result2?.signResult) ? result2?.signResult : []),
    ...(Array.isArray(result2?.signTask) ? result2?.signTask : [])
  ] : result2;
  dispatch({
    type: FULL_SIGNATURE.Details,
    payload: {
      ...result1,
      ...(businessFormNo.includes('CR') ? {
        gamShareofficeApplyDetailList: result1?.gamShareofficeChangeDetailList,
      } : {}),
      schedule,
    }
  });

  if(success1) return;
  toastError(message1)
};

//  查詢待審核下一條
export const querySignOffNextItem = () => async (dispatch, getState) => {
  const { success, result } = await queryTodoProcess({ pageNo: 1, pageSize: 1 });
  const { records, current, pages, size, total } = result || {};
  const [initial, ...others] = records || [];
  return { success, id: initial?.id, businessFormNo: initial?.businessFormNo }
};